import { Injectable, OnDestroy } from '@angular/core';
import { CmsIneligiblePage } from '@checkout/util-models';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { ResetFacade } from '@domgen/dgx-fe-common';
import { Observable, combineLatest } from 'rxjs';

export interface ViewModel {
  cmsData: CmsIneligiblePage;
}

@Injectable()
export class IneligibleComponentService implements OnDestroy {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
  });

  constructor(
    private readonly cmsContainer: CmsContainer<CmsIneligiblePage>,
    private readonly resetFacade: ResetFacade
  ) {}

  ngOnDestroy(): void {
    this.resetFacade.reset();
  }
}
